<template>
  <form @submit.prevent="onSearch">
    <div class="row mb-2">
      <div class="col-lg-4 col-md-6 col-sm-12"
          v-if="clientDropdown && clientDropdown.length">
        <SelectVue
            v-model="filters.clientId"
            :options="clientDropdown"
            :is-clear="true"
            :placeholder="$t('placeholder.client_name')"/>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12"
          v-if="officeDropdown && officeDropdown.length">
        <SelectVue
            v-model="filters.officeId"
            :options="officeDropdown"
            :is-clear="true"
            :placeholder="$t('placeholder.office_name')"/>
      </div>
      <div class="col-lg-2 col-sm-12 col-12 d-flex d-lg-block justify-content-center"
           v-if="
           clientDropdown && clientDropdown.length ||
           officeDropdown && officeDropdown.length
         ">

        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>
      </div>
    </div>
  </form>
</template>

<script setup lang="ts">
import SelectVue from '@/components/SelectVue.vue';
import {defineEmits, defineProps, toRefs} from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  clientDropdown: {
    type: Array,
    required: true,
  },
  officeDropdown: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['search']);

// Use toRefs to maintain reactivity
const {filters} = toRefs(props);
const clientDropdown = toRefs(props)['clientDropdown'];
const officeDropdown = toRefs(props)['officeDropdown'];

function onSearch() {
  emit('search', 1, undefined, filters.value);
}
</script>

<style scoped>
</style>
